import React, { useEffect, useState } from "react";
import { Main } from "../style/dashboard";
import Navbar from "../components/navbar";
import Button from "@mui/material/Button";
import { postData } from "../services/parcel";
import { connect } from "react-redux";
import { setData } from "../Redux/mainActions";
import { getData } from "../services/parcel";
import Card from "../components/dashboard/waiting";
import { ToastContainer, toast } from "react-toastify";
import CustomBottomNavigation from "../components/footer";

import "react-toastify/dist/ReactToastify.css";
function useForceUpdate() {
  let [value, setState] = useState(true);
  return () => setState(!value);
}
function Dashboard(props) {
  const [dataa, setData] = useState(null);
  const [daata, setDataa] = useState(null);

  const handleSubmit = async () => {
    try {
      const { data } = await getData();
      // setData(data.data.filter(a => a.request_status != 4));
      // console.log(data.data.trips.data)
      setData(data?.data?.trips?.data);
      if (data.status == 401 || 405) {
        window.open("/");
      }
    } catch (error) {
      // if (401 === error.response.status) {
      //   router.push("/login");
      // }
      // setLoading(false);
    }
  };
  useEffect(() => {
    handleSubmit();
    // setInterval(() => handleSubmit(), 1000);
  }, []);
  // console.log(dataa)
  return (
    <Main>
      <Navbar Button="/dashboard" Detatil="داشبورد" value={false} />
      {/* <Button href="/FromLoc" variant="contained" sx={{ marginTop: '100px', width: '200px', alignSelf: 'center', fontFamily: 'SansX' }}>
                ثبت سفارش جدید
            </Button> */}
      {dataa ? (
        <>
          {dataa?.map((dataa) => (
            <Card data={dataa} getData={handleSubmit} />
          ))}
        </>
      ) : (
        <>
          <p
            style={{
              fontFamily: "SansX",
              color: "gray",
              alignSelf: "center",
              marginTop: "30vh",
            }}
          >
            در حال بارگزاری اطلاعات
          </p>
          <Button
            href="/FromLoc"
            variant="contained"
            sx={{ width: "200px", alignSelf: "center", fontFamily: "SansX" }}
          >
            ثبت سفر جدید
          </Button>
        </>
      )}
      <CustomBottomNavigation label='ثبت سفر' route2='/history' route='/fromLoc'/>
    </Main>
  );
}
const mapStateToProps = (state) => {
  return {
    data: state.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setData: (value) => dispatch(setData(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
